<template>
  <div style="height: 100%">
    <div class="sa-flexbox" style="padding-bottom: 20px">
      <div class="sa-flexbox-body">
        <div class="d-flex flex-column">
          <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
            <b-col lg="3">
              <p>Records Totali: {{ rows }}</p>
            </b-col>
            <b-col lg="9">
              <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right"
                size="sm"></b-pagination>
            </b-col>
          </b-row>
        </div>
        <div class="b-table-sticky-header">
          <b-table sticky-header ref="table" stacked="lg" striped hover :items="items" :fields="fields"
            :current-page="currentPage" :per-page="perPage" :key="listKey" sort-icon-left head-variant="light"
            class="sa-b-table">
            <template #cell(tipologia)="row">
              <div v-if="row.item.ricette.length == 1">
                <strong> {{ row.item.ricette[0].tipologiaRicetta }} </strong>
              </div>
              <div v-else>
                <strong v-for="ricetta in row.item.ricette" :key="ricetta.id"> {{ ricetta.tipologiaRicetta }} -
                </strong>
              </div>
            </template>
            <template #cell(nre)="row">
              <div v-if="row.item.ricette.length == 1">{{ row.item.ricette[0].codiceBar1 }}{{
                row.item.ricette[0].codiceBar2 }}</div>
              <div v-else>
                <strong v-for="ricetta in row.item.ricette" :key="ricetta.id"> {{ ricetta.codiceBar1 }}{{
                  ricetta.codiceBar2 }} - </strong>
              </div>
            </template>
            <template #cell(priorita)="row">
              <div v-if="row.item.ricette.length == 1">
                <strong> {{ row.item.ricette[0].classePriorita }} </strong>
              </div>
            </template>
            <template #cell(statoAttuale)="row">
              {{ row.item.statoAttuale }}
              <div
                style="min-width: 22px; height: 22px; display: flex; justify-content: center; align-items: center; border-radius: 50%; color: white; font-weight: 600; background-color: ">
              </div>
            </template>
            <template #cell(assistito)="row">
              <span>{{ row.item.accettazione.accettazioneAnagrafica.cognome }} {{
                row.item.accettazione.accettazioneAnagrafica.nome }}</span>
              <br />
              <small>{{ row.item.accettazione.accettazioneAnagrafica.identificativo }}</small>
            </template>
            <template #row-details="row">
              <div v-for="ricetta in listaRicetteDetails[row.item.id]" :key="ricetta.id">
                <div class="sa-badge">
                  <span class="sa-badge-label" style="font-size: small">
                    {{ ricetta.codiceBar1 }}
                    {{ ricetta.codiceBar2 == null ? "Privata" : ricetta.codiceBar2 }}
                  </span>
                  <div class="sa-badge-data" v-for="prestazione of ricetta.prestazioni" :key="prestazione.id">
                    <div style="font-size: small">
                      <div
                        style="flex: 1; display: flex; justify-content: start; align-items: start; gap: 4px; font-size: 12px; padding: 5px">
                        <span class="sa-badge-label">{{ prestazione.codicePrestazione }} {{
                          prestazione.descrizionePrestazione }}</span>
                        <span class="badge" :style="{
                          minWidth: '18px',
                          height: '18px',
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          borderRadius: '50%',
                          background: getColorBackGround(prestazione),
                          color: 'white',
                          fontWeight: '600',
                          boxShadow: '0 2px 5px rgba(0, 0, 0, 0.2)',
                        }">
                          {{ prestazione.appuntamenti ? prestazione.appuntamenti.length : 0 }}
                        </span>
                        <span style="font-weight: 800">/</span>
                        <span class="badge"
                          style="min-width: 18px; height: 18px; display: flex; justify-content: center; align-items: center; border-radius: 50%; background: #00a3ff; color: white; font-weight: 600; box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2)">
                          {{ prestazione.quantita }}
                        </span>
                      </div>
                    </div>
                    <h4 v-if="prestazione.appuntamenti[0]" style="padding: 3px">Appuntamenti:</h4>
                    <div class="sa-badge-internal" v-for="appuntamento of prestazione.appuntamenti"
                      :key="appuntamento.id" style="align-items: center; text-align: center">
                      <div class="sa-badge-label">
                        <span style="width: 100%; display: inline-block;">{{ appuntamento.titolo }}</span>
                        {{ formatDate(appuntamento.dataOraInizio) }}
                      </div>
                      <div class="sa-badge-label">{{ getOra(appuntamento.dataOraInizio) }} - {{
                        getOra(appuntamento.dataOraFine) }}</div>
                      <span>{{ appuntamento.descrizionePrestazione }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <template #cell(actions)="row">
              <b-button size="sm" v-b-tooltip.hover title="Prestazioni" variant="outline-primary"
                @click="onClickDettaglio(row)">
                <font-awesome-icon :icon="row.item._showDetails ? 'arrow-down' : 'arrow-left'" />
              </b-button>
              <b-button size="sm" class="mr-1 ml-1 no-text" variant="outline-secondary"
                @click="onClickOpenDetailAccettazione(row.item)">
                <i class="bi bi-eye"></i>
              </b-button>
              <!-- @click="onPrintPreview(row.item)" -->
              <b-button size="sm" variant="btn btn-purple waves-effect  waves-light width-sm no-text"
                @click="onClickAnteprimaStampa(row.item)" style="margin-right: 3px">
                <b-icon icon="printer"></b-icon>
              </b-button>
              <!-- <print-component :jsonData="item" :linkPrintData="linkPrintData(item)" typeButton="small" :firmaGrafometrica="true"></print-component> -->
            </template>
          </b-table>
        </div>
      </div>
      <div class="d-flex flex-column">
        <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
          <b-col lg="3">
            <p>Records Totali: {{ rows }}</p>
          </b-col>
          <b-col lg="9">
            <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right"
              size="sm"></b-pagination>
          </b-col>
        </b-row>
      </div>
      <b-modal></b-modal>

      <pdf-print-view-embedded ref="pdfPrintViewEmbedded" :pdf="signedPdfViewer"></pdf-print-view-embedded>
    </div>
  </div>
</template>

<script>
import axios from "axios";
// import PrintComponent from "../../../utility/components/PdfPrintViewEmbedded.vue";
import UtilityMixin from "../../../utility/UtilityMixin";
import PdfPrintViewEmbedded from "../../../utility/components/PdfPrintViewEmbedded.vue";
// import PrintComponent from "../../../utility/components/PrintComponent.vue";
import moment from "moment";
export default {
  //PrintComponent
  mixins: [UtilityMixin],
  components: { PdfPrintViewEmbedded },
  data() {
    return {
      pathResource: "/accettazionessn",
      pathResourceRicette: "/accettazionericette",
      items: null,
      rows: 0,
      filtro: {
        codiceFiscaleAssistito: null,
        idPresidio: null,
      },
      page: 1,
      perPage: 10000,
      signedPdfViewer: null,
      listKey: 0,
      previewSelected: null,
      currentPage: 1,
      rowSelectedAccettazione: {},
      listaRicetteDetails: {},
      fields: [
        {
          label: "Tipo Ricetta",
          key: "tipologia",
        },
        {
          label: "Priotità",
          key: "priorita",
        },
        {
          label: "NRE",
          key: "nre",
        },
        {
          label: "C.F Assistito",
          key: "assistito",
        },
        {
          label: "Stato",
          key: "statoAttuale",
        },
        {
          label: "Data Ora",
          key: "createDate",
          formatter: (param) => {
            return UtilityMixin.methods.formatDateTime(param);
          },
        },

        {
          label: "",
          class: "sa-table-column-action-double",
          key: "actions",
        },
      ],
    };
  },
  mounted() {
    let me = this;
    me.init();
  },
  methods: {
    init() {
      let me = this;
      me.loadData();
    },
    getOra(date) {
      return moment(date).format("HH:mm");
    },
    getFormatDate(date) {
      return moment(date).format("DD/mm/yyyy");
    },
    loadData() {
      let me = this;
      me.$emit("beforeLoadData");
      me.items = [];
      let filtroStr = sessionStorage.getItem("filtroPageAccettazioneSsn");
      let filtroJson = JSON.parse(filtroStr);
      me.filtro = filtroJson;
      if (me.filtro != null) {
        me.filtro.page = me.currentPage;
        me.filtro.forPage = me.perPage;
        if (me.filtro.idPresidio == null) {
          me.$emit("afterLoadData");
          me.$bvToast.toast("Selezionare Presidio!!", {
            title: "Azione Obbligatoria",
            variant: "warning",
            solid: true,
          });
          return;
        }
      }

      UtilityMixin.methods.loadDataResources(me.pathResource, me.filtro, me.loadDataAccettazioneSsnSuccess, me.loadDataAccettazioneSsnError);
    },

    loadDataAccettazioneSsnSuccess(response) {
      let me = this;
      me.items = response.data.data.list;
      me.rows = response.data.data.recordsNumber;
      me.listKey++;
      me.$emit("afterLoadData");
    },
    loadDataAccettazioneSsnError(response) {
      let me = this;
      me.$emit("afterLoadData", response);
      console.log(response);

      me.$bvToast.toast(response.response.data.messaggio, {
        title: "Errore",
        variant: "danger",
        solid: true,
      });
    },
    getColorBackGround(prestazione) {
      let color = "#b6b5b5";
      color = prestazione.appuntamenti.length == prestazione.quantita ? "#00a3ff" : "#ffc107";
      return color;
    },
    linkPrintData(item) {
      let returnValue = "/printer/" + item.id;
      return returnValue;
    },
    onClickOpenDetailAccettazione(accettazione) {
      this.$router.push("accettazionessn/" + accettazione.id);
    },
    onClickDettaglio(row) {
      if (this.listaRicetteDetails[row.item.id]) {
        row.toggleDetails();
      } else {
        this.loadRicetteByAccettazione(row);
      }
    },
    loadRicetteByAccettazione(row) {
      let link = process.env.VUE_APP_PATH_API + this.pathResourceRicette;
      axios
        .get(link, { params: { idAccettazione: row.item.id } })
        .then((response) => {
          this.listaRicetteDetails[row.item.id] = response.data.data.list;
          row.toggleDetails();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    onClickAnteprimaStampa(item) {
      let me = this;
      let prestazioni = null;
      let identificativo = item.accettazione.accettazioneAnagrafica.identificativo;
      if (item.ricette.length >= 1) {
        prestazioni = item.ricette[0].prestazioni;
      } else {
        //TODO
      }
      let print = {
        reportName: "RegistroPresenze",
        data: {
          identificativo: identificativo,
          prestazioni: prestazioni,
        },
      };
      me.onPrintPreview(print);
    },
    onClickAnnulla() {
      let me = this;
      me.$refs.mdlPreviewStampa.hide();
    },
    onPrintPreview(item) {
      let me = this;
      let link = process.env.VUE_APP_PATH_API + "/print/createreport";
      me.showModalLoading = true;
      axios
        .post(link, item)
        .then((response) => {
          me.signedPdfViewer = "data:application/pdf;base64," + response.data.base64;

          me.$refs.pdfPrintViewEmbedded.show();
        })
        .catch((error) => {
          // me.$refs.mdlGenerazioneReportInCorso.hide();
          me.showModalLoading = false;
          let messaggio = error.response.data.messaggio ? error.response.data.messaggio : "Errore non gestito, Codice: " + error.response.status;
          this.$bvModal
            .msgBoxOk(messaggio, {
              title: this.$i18n.t("ERROR!"),
              size: "sm",
              okVariant: "outline-danger",
              headerClass: "sa-msg-header-danger",
              footerClass: "p-2 border-top-0",
              centered: true,
            })
            .then((value) => {
              this.boxTwo = value;
            })
            .catch((err) => {
              err;
            });
        });
    },
  },
  watch: {
    // currentPage() {
    //   let me = this;
    //   me.loadData();
    // },
  },
};
</script>

<style scoped>
.ft-wrapper-ricetta {
  margin-bottom: 16px;
}

.ft-ricetta-titolo {
  font-weight: 600;
  display: block;
  margin-bottom: 8px;
}

/* Prestazioni orizzontali */
.ft-wrapper-prestazioni {
  display: flex;

  gap: 16px;
}

.ft-prestazione-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 8px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background: #f9f9f9;
}

.ft-prestazione-codice {
  font-weight: 600;
  margin-bottom: 6px;
}

.ft-prestazione-badge-container {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
}

.ft-badge {
  min-width: 22px;
  height: 22px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  color: white;
  font-weight: 600;
}

.ft-badge-complete {
  background-color: #00a3ff;
}

.ft-badge-incomplete {
  background-color: #ffc107;
}

.ft-badge-total {
  background-color: #00a3ff;
}

.sa-badge-internal {
  border-radius: 5px;
  border-left: 4px solid var(--bg-sidebar-item);
  border-top: 1px solid var(--bg-main-nav-bar);
  border-bottom: 1px solid var(--bg-main-nav-bar);
  border-right: 1px solid var(--bg-main-nav-bar);
  padding: 7px !important;
  margin-bottom: 5px;
  max-width: max-content;
}

.sa-badge {
  width: 100%;
  max-width: none !important;
}
</style>
